/**
 * @generated SignedSource<<8b2065d48e2a6679a1318ff793462f4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompositionChart_component$data = {
  readonly data: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly name: string | null | undefined;
    readonly percent: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly disclaimer: string | null | undefined;
  readonly " $fragmentType": "CompositionChart_component";
};
export type CompositionChart_component$key = {
  readonly " $data"?: CompositionChart_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompositionChart_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompositionChart_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompositionChartData",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disclaimer",
      "storageKey": null
    }
  ],
  "type": "CompositionChart",
  "abstractKey": null
};

(node as any).hash = "d0392c32b5e193ad7076fc029e36ac21";

export default node;
